module.exports = __webpack_public_path__ + "img/6e26520.jpg";